import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'
import NotFound from "@/views/NotFound";
// import Clubs from '@/views/Clubs';
// import Features from '@/views/Features';
import HowItWorks from '@/views/HowItWorks';
import Support from '@/views/Support';
import Instructions from '@/views/Instructions';
import About from '@/views/About';
import PrivayPolicy from '@/views/PrivayPolicy';
import SoftwareLicenseAgreement from '@/views/SoftwareLicenseAgreement';
import GeneralTermsAndConditions from '@/views/GeneralTermsAndConditions';
import Contact from '@/views/Contact';
import Coaches from '@/views/Coaches';
import CoachProfile from '@/views/CoachProfile';
import CoachProfilePrivate from '@/views/CoachProfilePrivate';
import HireCoachRequest from '@/views/HireCoachRequest';
import HireCoachConfirmation from '@/views/HireCoachConfirmation';
import DemoConfirmation from '@/views/DemoConfirmation';
import RequestDemo from '@/views/RequestDemo';
// import GiveawayTerms from '@/views/GiveawayTerms';
import PaymentSuccess from '@/views/PaymentSuccess';
import MindfulAssesment from '@/views/mindfulcricket/MindfulAssesment';
import Articles from '@/views/Articles';
import Article from '@/views/Article';
import Press from '@/views/Press';
import Release from '@/views/Release';
// import Pricing from '@/views/Pricing';
import Player from '@/views/landingpages/Player';
import Parent from '@/views/landingpages/Parent';


Vue.use(Router)

const LAYOUT_NO_HEADER = "no-header";
const LAYOUT_NO_HEADER_FOOTER = "no-header-footer";

export default new Router({
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
		if (to.hash) {
			return { selector: to.hash }
		} else if (savedPosition) {
      return savedPosition;
    } else {
			return { x: 0, y: 0 }
		}
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    // {
    //   path: '/clubs',
    //   name: 'clubs',
    //   component: Clubs
    // },
    // {
    //   path: '/features',
    //   name: 'features',
    //   component: Features
    // },
    {
      path: '/how-it-works',
      name: 'how-it-works',
      component: HowItWorks
    },
    {
      path: '/support',
      name: 'support',
      component: Support
    },
    {
      path: '/instructions',
      name: 'instructions',
      component: Instructions
    },
    
    {
      path: '/about',
      name: 'about',
      component: About
    },
    {
      path: '/privay-policy',
      name: 'privay-policy',
      component: PrivayPolicy
    },
    {
      path: '/software-license-agreement',
      name: 'software-license-agreement',
      component: SoftwareLicenseAgreement
    },
    {
      path: '/general-terms-and-conditions',
      name: 'general-terms-and-conditions',
      component: GeneralTermsAndConditions
    },
    {
      path: '/contact',
      name: 'contact',
      component: Contact
    },
    {
      path: '/coaches',
      name: 'coaches',
      component: Coaches
    },
    {
      path: '/coach-profile/:id',
      name: 'coach-profile',
      component: CoachProfile
    },
    {
      path: '/exclusive-coach/:slug',
      name: 'exclusive-coach',
      component: CoachProfilePrivate
    },
    {
      path: "/hire-coach-form/:id",
      name: "hire-coach-form",
      component: HireCoachRequest
    },
    {
      path: "/hire-coach-confirmation",
      name: "hire-coach-confirmation",
      component: HireCoachConfirmation
    },
    {
      path: "/request-demo",
      name: "request-demo",
      component: RequestDemo,
      meta: { layout: LAYOUT_NO_HEADER }
    },
    {
      path: "/request-demo-confirmation",
      name: "request-demo-confirmation",
      component: DemoConfirmation,
      meta: { layout: LAYOUT_NO_HEADER }
    },
    {
      path: "/error",
      name: "error",
      component: NotFound,
    },
    // {
    //   path: "/bat-giveaway-terms-and-conditions",
    //   name: "bat-giveaway-terms-and-conditions",
    //   component: GiveawayTerms
    // },
    {
      path: "/payment_successful",
      name: "payment_successful",
      component: PaymentSuccess
    },
    {
      path: "/mindful-cricket-self-assesment",
      name: "mindful-cricket-self-assesment",
      component: MindfulAssesment,
      meta: { layout: LAYOUT_NO_HEADER_FOOTER }
    },
    // News
    {
      path: "/latest-articles",
      name: "latest-articles",
      component: Articles,
    },
    {
      path: "/article/:name",
      name: "article",
      component: Article
    },
    // Press
    {
      path: "/press",
      name: "press",
      component: Press,
    },
    {
      path: "/release/:name",
      name: "release",
      component: Release
    },
    // {
    //   path: "/pricing",
    //   name: "pricing",
    //   component: Pricing,
    // },
    {
      path: "/landing-page/parent",
      name: "landing-page/parent",
      component: Parent,
      meta: { layout: LAYOUT_NO_HEADER_FOOTER }
    },
    {
      path: "/landing-page/cricketers",
      name: "landing-page/cricketers",
      component: Player,
      meta: { layout: LAYOUT_NO_HEADER_FOOTER }
    },
    {
      path: "*",
      component: NotFound,
    }
  ]
})
